import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.33, d: "m.707.706 10.588 10.588M11.295.706.707 11.294" }));
const ForwardRef = forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
